
import LineString from 'ol/geom/LineString';
import VectorSource from 'ol/source/Vector';

import DrawMeasure from './DrawMeasure';
import { styleFunction } from './measureStyle';
import { calculateMeasureValuesInGeometry } from './measureValues';

function createInteractionMeasureLine(options) {

    const MAP_TOOL_ID = 'MeasureLine';

    let coords = [];
    let actualGeometry = null;

    const handleChangeGeometry = (geometry, action) => {
        if (options.onMapToolExecute) {
            coords = geometry.getCoordinates().map(item => {
                return {
                    x: item[0],
                    y: item[1],
                    z: 0
                };
            });

            const values = calculateMeasureValuesInGeometry(
                geometry,
                ['id', 'length', 'lengthXY', 'lengthLastSegment', 'coords']
            );

            handleMapToolExecute(
                coords,
                values,
                action,
                geometry
            );
        }
    }

    const handleMapToolExecute = (coords_, values_ = {}, action_ = 'measureupdated', geometry_ = null) => {
        if (options.onMapToolExecute) {
            options.onMapToolExecute(
                MAP_TOOL_ID,
                {
                    action: action_,
                    values: {
                        ...values_,
                        coords: coords_
                    },
                    geometry: geometry_
                }
            );
        }
    }

    const handlePointerMove = (event) => {
        if (coords.length === 0) {
            handleMapToolExecute([{
                x: event.coordinate[0],
                y: event.coordinate[1],
                z: 0
            }]);
        }
    }

    const handleDrawAbort = () => {
        coords = [];
        handleMapToolExecute(coords);
    }

    const handleDrawEnd = () => {
        handleChangeGeometry(actualGeometry, 'measureend');
        coords = [];
        handleMapToolExecute(coords);
    }

    const geometryFunction = (coordinates, geometry, projection) => {
        if (geometry) {
            geometry.setCoordinates(coordinates);
        } else {
            geometry = new LineString(coordinates);
        }
        actualGeometry = geometry;
        handleChangeGeometry(geometry);
        return geometry;
    };

    let source = new VectorSource({});

    let draw = new DrawMeasure({
        source: source,
        type: 'LineString',
        geometryFunction: geometryFunction,
        style: function (feature) {
            return styleFunction(feature, true, 'LineString', null);
        },
        onPointerMove: function (event) {
            handlePointerMove(event);
        }
    });

    draw.on('drawabort', handleDrawAbort);
    draw.on('drawend', handleDrawEnd);

    draw.set('mapToolId', MAP_TOOL_ID);
    draw.setActive(false);

    return draw;
}

export default createInteractionMeasureLine;
